import { http } from '@/lib/ats-https';

export interface CreateSurveyPayload {
  ats_job_stage_action_id: string;
  ats_application_id: string;
}

export interface InviteSurveyPayload {
  surveyId: string;
  ats_job_stage_id: string;
  ats_job_stage_action_id: string;
  ats_application_id: string;
  params: any;
}

export interface InviteAdhocSurveyPayload extends InviteSurveyPayload {}

const SURVEY_ENDPOINTS = {
  create: '/ats_surveys',
  get: (id: string) => `/ats_surveys/${id}`,
  update: (id: string) => `/ats_surveys/${id}`,
  new: '/ats_surveys/new',
  cancelSchedule: (id: string) => `/ats_surveys/${id}/cancel_schedule`,
  delete: (id: string) => `/ats_surveys/${id}`,
};

export const SURVEY_API = {
  createSurvey: async (payload: CreateSurveyPayload | FormData) => {
    const response = await http.post(SURVEY_ENDPOINTS.create, payload);
    return response;
  },

  getSurvey: async (surveyId: string) => {
    const response = await http.get(SURVEY_ENDPOINTS.get(surveyId));
    return response.data;
  },

  updateSurvey: async (surveyId: string, params: any | FormData) => {
    const response = await http.patch(
      SURVEY_ENDPOINTS.update(surveyId),
      params
    );
    return response;
  },

  getNewSurvey: async (params: {
    ats_application_id: string;
    ats_job_stage_id: string;
    ats_job_stage_action_id: string;
  }) => {
    const response = await http.get(SURVEY_ENDPOINTS.new, { params });
    return response.data;
  },

  cancelScheduledSurvey: async (surveyId: string) => {
    const response = await http.put(SURVEY_ENDPOINTS.cancelSchedule(surveyId));
    return response;
  },

  deleteSurvey: async (surveyId: string) => {
    const response = await http.delete(SURVEY_ENDPOINTS.delete(surveyId));
    return response;
  },

  sendSurveyNow: async (surveyId: string) => {
    const response = await http.post(SURVEY_ENDPOINTS.create, {
      ats_survey_id: surveyId,
    });
    return response;
  },

  getApplicationSurveys: async (applicationId: string) => {
    const response = await http.get(
      `/ats_applications/${applicationId}/surveys`
    );
    return response;
  },
};

export const getSurveyFormData = (formData, values) => {
  const {
    label,
    subject,
    body,
    attachments = [],
    from,
    senderId,
    cc = [],
    bcc = [],
    survey_id = '',
    ats_comm_template_id = '',
    ats_shared_email_id = undefined,
    survey_type = 'survey',
    toAddress = [],
    schedule_at,
    email_template_name = '',
  } = values;
  let hasTemplateAttachments = false;
  formData.append('label', label);
  formData.append('kind', 'survey');
  formData.append('mode', 'manual');

  if (senderId) {
    formData.append('sender_id', senderId);
  } else if (from) {
    formData.append('sender_id', from);
  }

  if (ats_shared_email_id) {
    formData.append('ats_shared_email_id', ats_shared_email_id);
  }

  formData.append('name', label);
  formData.append('survey_type', survey_type);
  formData.append('ats_form_template_id', survey_id);

  formData.append('subject', subject);
  formData.append('body', body);
  if (email_template_name) {
    formData.append('email_template_name', email_template_name);
  }
  if (survey_type === 'employee') {
    toAddress?.forEach((id) => {
      formData.append('participant_ids[]', id);
    });
  }

  //   'ats_comm_template_association_attributes[ats_comm_template_attributes][channel]',
  //   'email'
  // );

  cc?.forEach((id) => {
    formData.append('cc[]', id);
  });
  bcc?.forEach((id) => {
    formData.append('bcc[]', id);
  });
  attachments.forEach((file, index) => {
    if (file instanceof File) {
      formData.append(
        'candidate_comm_template_attributes[attachments][]',
        file
      );
    }
    if (file?.id) {
      hasTemplateAttachments = true;
      formData.append(
        'candidate_comm_template_attributes[attachments][]',
        file?.id
      );
    }
  });

  if (attachments?.length === 0) {
    formData.append('candidate_comm_template_attributes[attachments][]', []);
  }

  if (hasTemplateAttachments && ats_comm_template_id) {
    formData.append('ats_comm_template_id', ats_comm_template_id);
  }

  // Scheduling
  if (schedule_at?.formattedTime) {
    formData.append('scheduled_at', schedule_at.formattedTime);
  }
  if (schedule_at?.timezoneValue?.key) {
    formData.append('timezone', schedule_at.timezoneValue.key);
  }

  return formData;
};
